@if (showExternal) {
<product-view-external [variant]="model.ppExternalLayoutVariant"
                       [product]="model"
                       [productLayoutContent]="productLayoutModel?.data?.content" />
} @else {
<product-view-layout [variant]="model.ppLayoutVariant"
                     [product]="model" />
}